import { Outlet, createFileRoute } from '@tanstack/react-router';

import Plugins from 'component/view/SiteDetails/Plugins';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/plugins')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.plugins(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: PluginsLayout,
});

function PluginsLayout() {
  return (
    <Plugins>
      <Outlet />
    </Plugins>
  );
}
